// Registry of editable site images. Each slot has a stable key, an admin-facing
// label, and the bundled default used when no admin override is set.
export const SITE_IMAGE_SLOTS = [
  { key: "logo", label: "Site Logo (header, footer, admin login)", default: "/assets/lane4-logo.png" },
  { key: "home_hero", label: "Home Page — Hero Background", default: "https://images.unsplash.com/photo-1714190831908-9c935482d814?w=1920" },
  { key: "etickets_hero", label: "E-Tickets Page — Hero Image", default: "/assets/etickets-hero.png" },
  { key: "events_coach_miami", label: "Events Page — Coach Miami Image", default: "/assets/events/coach-miami.jpg" },
  { key: "alldone_logo", label: "Thank-You Page — Logo", default: "/assets/spectators-tickets-logo.png" },
  // Blank by default: until an image is uploaded the header falls back to a
  // plain red "Donate" button, so it is never rendered broken.
  { key: "donate_button_image", label: "Donate Button Image (blank = plain red button)", default: "" },
  { key: "medal_1", label: "Medal Gallery — Image 1", default: "/assets/medals/bin-02.jpg", circle: true },
  { key: "medal_2", label: "Medal Gallery — Image 2", default: "/assets/medals/dmv-sprintfest2.jpg", circle: true },
  { key: "medal_3", label: "Medal Gallery — Image 3", default: "/assets/medals/mpower01.jpg", circle: true },
  { key: "medal_4", label: "Medal Gallery — Image 4", default: "/assets/medals/nfx-01.jpg", circle: true },
  { key: "medal_5", label: "Medal Gallery — Image 5", default: "/assets/medals/titan-02.jpg", circle: true },
];

// Medal gallery videos. `title` is the caption shown on the gallery tile.
export const MEDAL_VIDEO_SLOTS = [
  { key: "medal_video_1", title: "DMV Sprintfest", default: "/assets/medals/videos/dmv-sprintfest.mp4" },
  { key: "medal_video_2", title: "Dynasty Elite", default: "/assets/medals/videos/dynasty-elite-3.mp4" },
  { key: "medal_video_3", title: "Memorial Classic", default: "/assets/medals/videos/memorial-01.mp4" },
  { key: "medal_video_4", title: "Out The Mud", default: "/assets/medals/videos/out-the-mud-2.mp4" },
  { key: "medal_video_5", title: "Bring The Heat", default: "/assets/medals/videos/bring-the-heat.mp4" },
  { key: "medal_video_6", title: "Bay Champs", default: "/assets/medals/videos/bay-champs.mp4" },
  { key: "medal_video_7", title: "Five Star General", default: "/assets/medals/videos/fsg-shoe.mp4" },
  { key: "medal_video_8", title: "Icon", default: "/assets/medals/videos/icon-ring-2.mp4" },
  { key: "medal_video_9", title: "Blazin Ravens", default: "/assets/medals/videos/blazin-ravens.mp4" },
  { key: "medal_video_10", title: "Birmingham Indoor Nationals", default: "/assets/medals/videos/bin-2.mp4" },
  { key: "medal_video_11", title: "Diocese", default: "/assets/medals/videos/diocese-cc.mp4" },
  { key: "medal_video_12", title: "Florida National Championships", default: "/assets/medals/videos/florida-national-championship.mp4" },
];

// Editable embed URLs (third-party widgets shown on public pages).
export const SITE_EMBED_SLOTS = [
  {
    key: "etickets_embed_url",
    label: "E-Tickets Page — Ticket Widget URL",
    help: "Global E Tickets event link. Open your event, copy its share/embed link, and paste it here.",
    default: "https://globaletickets.com/e/lane4-sales/be-out-day?embed=true",
  },
  {
    key: "events_embed_url",
    label: "Events Page — “Get Your Tickets” Widget URL",
    help: "Paste your multi-event Global E Tickets link here to show the “Get Your Tickets” section on the Events page. While this is blank the section is hidden.",
    default: "",
  },
];

export const DEFAULT_SITE_IMAGES = Object.fromEntries([
  ...SITE_IMAGE_SLOTS.map((slot) => [slot.key, slot.default]),
  ...MEDAL_VIDEO_SLOTS.map((slot) => [slot.key, slot.default]),
  ...SITE_EMBED_SLOTS.map((slot) => [slot.key, slot.default]),
]);

// Alt text for the medal gallery slots (kept alongside the slot keys).
export const MEDAL_GALLERY = [
  { key: "medal_1", alt: "Birmingham Indoor Nationals" },
  { key: "medal_2", alt: "DMV Sprintfest" },
  { key: "medal_3", alt: "MPowered Athletix" },
  { key: "medal_4", alt: "North Florida Xpress" },
  { key: "medal_5", alt: "Titan Track Classic" },
];
